import React from 'react';
import { bonuses } from '../data/kit';
export function Bonuses() {
  return <section className="bg-lila-100 py-9 md:py-16 px-4" data-id="element-12" data-mp="pjzkxa465ib9">
      <div className="max-w-5xl mx-auto" data-id="element-13" data-mp="pjg6w4hn3e2i">
        <div className="text-center mb-6 md:mb-10 max-w-3xl mx-auto" data-id="element-14" data-mp="avcxel4e1k8y">
          <h2 className="font-serif text-[25px] md:text-[42px] font-bold text-wine tracking-tight leading-[1.12]" data-id="element-15" data-mp="asz5um8x2q65">
            5 BONOS PARA QUE PRACTICAR NO SE SIENTA SIEMPRE IGUAL 🎁
          </h2>
          <p className="text-ink-muted text-[15px] md:text-lg leading-snug mt-2.5 md:mt-4" data-id="element-16" data-mp="1whr791cga5n">
            No son material de relleno. Cada bono cumple una función diferente
            dentro del recorrido.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-17" data-mp="3t0g4uchtu8cj">
          {bonuses.map((bono, i) => <article key={bono.title} className="flex flex-col rounded-2xl border border-lila-200 bg-white overflow-hidden" data-id="element-18" data-mp="1m9yun7w22mvf" data-mpi={i}>
              {bono.image && <div className="bg-cream-50 aspect-[4/3] md:aspect-[3/4] overflow-hidden" data-id="element-19" data-mp="3idmz7yg0j9gl">
                  <img src={bono.image} alt={`Vista previa de ${bono.title}`} className="w-full h-full object-cover object-top" loading="lazy" decoding="async" data-id="element-20" data-mp="3dfv836n6zrdg" />
                </div>}
              <div className="flex gap-3.5 md:flex-col md:gap-0 p-4 md:p-6" data-id="element-21" data-mp="2zglri5v2qv8y">
                <p className="font-serif text-3xl md:text-4xl font-bold text-lila-300 leading-none tabular-nums shrink-0" data-id="element-22" data-mp="2uh0qzr09aeu4">
                  {String(i + 1).padStart(2, '0')}
                </p>
                <div className="min-w-0" data-id="element-23" data-mp="33hfduusvc1zq">
                  <h3 className="font-serif font-bold text-wine text-base md:text-lg leading-snug md:mt-3" data-id="element-24" data-mp="33fm6teecffr7">
                    {bono.title}
                  </h3>
                  <p className="font-bold text-lila-600 text-[15px] leading-snug mt-1" data-id="element-25" data-mp="irgakymrqh3g">
                    {bono.lead}
                  </p>
                  <p className="text-ink-muted text-sm leading-snug md:leading-relaxed mt-1.5" data-id="element-26" data-mp="3ciepvenhwf4d">
                    {bono.desc}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}